import React, { useEffect } from 'react'
import ReactModal from 'react-modal'
import { useTranslation } from 'react-i18next'
import { ReactComponent as DeleteIcon } from '../../svg/normalSvgs/DeleteIcon.svg'

function ConfirmationModal({ modalIsOpen, closeModal, confirmation, message, subMessage, okButtonText = 'delete', showDeleteIcon = true }) {
    const { t } = useTranslation()

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root')
            try {
                document.getElementById('my-header').style.filter = 'blur(5px)'
                document.getElementById('profileId').style.filter = 'blur(5px)'
            } catch (e) {}
        } else {
            try {
                document.getElementById('my-header').style.filter = 'unset'
                document.getElementById('profileId').style.filter = 'unset'
            } catch (e) {}
        }
    }, [modalIsOpen])

    return (
        <ReactModal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={{
                overlay: { zIndex: 14 },
                content: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    padding: 0,
                    border: 'none',
                    boxShadow: 'none',
                },
            }}
        >
            <div className="confirmModal_container">
                <div className="confirmModal_background">
                    <div className="confirmModal_header">
                        <div className="confirmModal_title">{message}</div>
                        {subMessage && <div className="confirmModal_subtitle">{subMessage}</div>}
                    </div>

                    <div className="confirmModal_actions">
                        <button className="confirmModal_btn confirmModal_btnPrimary" onClick={confirmation}>
                            {t(okButtonText)}
                            {showDeleteIcon && <DeleteIcon className="confirmModal_icon" />}
                        </button>

                        <button className="confirmModal_btn confirmModal_btnSecondary" onClick={closeModal}>
                            {t('cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </ReactModal>
    )
}

export default ConfirmationModal
